export default {
  methods: {
    openAlert: function () {
      var self = this;
      self.$app.dialog.alert('Hello World');
    }
  },
  on: {
    pageBeforeRemove: function (e, page) {
      var $page = this.$$(page.el);
      $page.off('submit');
      $page.off('click');
    },
    pageInit: function (e, page) {
      const app = this.$app;
      const $$ = this.$;
      const opt_registration = true;
      var $page = $$(page.el);
      $page.off('submit');
      $page.off('click');
      $page.on('submit', '#enterMobileForm', function (e) {
        e.preventDefault();
        var mobile = $page.find('input[name="mobile"]').val();
        app.preloader.show();
        var url = app.data.remoteUrl + 'auth/check-mobile/' + mobile;
        app.request.json(url, function (data) {
          app.preloader.hide();
          console.log(data);
          if (data.status) {
            console.log('OTP sent, is_registered:', data.data ? data.data.is_registered : 'unknown');
            startTimer(10);
            $page.find('#sendOtpMobile').html(mobile);
            $page.find('#div1').hide();
            $page.find('#div2').show();
          } else {
            app.dialog.alert(data.msg, 'Error');
          }
        }, function (xhr) {
          app.preloader.hide();
          app.methods.requestError(xhr);
        });
      });
      $page.on('submit', '#OTPvalidateForm', function (e) {
        e.preventDefault();
        var mobile = $page.find('#sendOtpMobile').text().trim();
        var otp = $page.find('input[name="otp"]').val();
        var playerID = localStorage.getItem('playerID') || '';
        var payload = {
          mobile: mobile,
          otp: otp,
          one_signal_id: playerID
        };
        console.log('OTP Payload:', payload);
        app.preloader.show();
        fetch(app.data.remoteUrl + 'auth/verify-otp', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(payload)
        }).then(function (response) {
          return response.json();
        }).then(function (data) {
          app.preloader.hide();
          console.log(data);
          if (data.status && data.token) {
            localStorage.setItem('token', data.token);
            localStorage.setItem('name', data.name || '');
            localStorage.setItem('mobile', data.mobile || mobile);
            var city = localStorage.getItem('city');
            if (city == null || city == '') {
              localStorage.setItem('city', '1');
            }
            $$('#loginUserName').text(data.name || '');
            app.views.main.router.navigate('/home/');
            app.views.main.router.clearPreviousHistory();
          } else {
            app.dialog.alert(data.msg || 'Invalid OTP', 'Verification Failed');
            console.log('invalidOTP');
          }
        }).catch(function (error) {
          app.preloader.hide();
          console.log('Fetch error:', error);
          app.dialog.alert('Unable to connect. Please check your internet connection.', 'Connection Error');
        });
      });
      $page.on('click', '#changesNumber', function (e) {
        $page.find('#div1').show();
        $page.find('#div2').hide();
      });
      $page.on('click', '#resentOTP', function (e) {
        e.preventDefault();
        var mobile = $page.find('#sendOtpMobile').text().trim();
        app.preloader.show();
        var url = app.data.remoteUrl + 'auth/resend-otp/' + mobile;
        app.request.json(url, function (data) {
          app.preloader.hide();
          if (data.status) {
            app.dialog.alert(data.msg || 'OTP sent', 'Success');
            $page.find('#timer').show();
            $page.find('#resentOTP').hide();
            startTimer(10);
          } else {
            app.dialog.alert(data.msg || 'Error sending OTP', 'Error');
          }
        }, function (xhr) {
          app.preloader.hide();
          app.methods.requestError(xhr);
        });
      });
      function startTimer(timeleft) {
        var timeShow = '';
        $page.find('#timer').show();
        $page.find('#resentOTP').hide();
        var downloadTimer = setInterval(function () {
          if (timeleft < 10)
            timeShow = '0' + timeleft;
          else
            timeShow = timeleft;
          $page.find('#countdown').html(timeShow);
          timeleft -= 1;
          if (timeleft < 0) {
            clearInterval(downloadTimer);
            $page.find('#timer').hide();
            $page.find('#resentOTP').show();
          }
        }, 1000);
      }
    }
  },
  id: '22ed37db07',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page auth-page" data-name="sign_in">\n        <div class="page-content">\n            <div class="auth-hero">\n                <img class="auth-hero-logo" src="static/img/mdoc-logo.svg" alt="mDOC">\n            </div>\n\n            <div id="div1" style="display:block">\n                <div class="auth-hero">\n                    <h1 class="auth-hero-title">Verify your mobile</h1>\n                    <p class="auth-hero-sub">Enter your mobile number and we\'ll send you a verification code.</p>\n                </div>\n                <form id="enterMobileForm">\n                    <div class="auth-card">\n                        <div class="list inline-labels no-hairlines-md">\n                            <ul>\n                                <li class="item-content item-input auth-field">\n                                    <div class="item-inner">\n                                        <div class="item-input-wrap input_mobile">\n                                            <span class="contry_code">+91</span>\n                                            <input type="text" placeholder="Mobile Number" maxlength="10" minlength="10" name="mobile" required validate pattern="[0-9]*" data-error-message="Please enter valid mobile mumber !!" value="">\n                                            <span class="input-clear-button"></span>\n                                        </div>\n                                    </div>\n                                </li>\n                            </ul>\n                        </div>\n                    </div>\n                    <div class="auth-note">\n                        <i class="icon material-icons">enhanced_encryption</i>\n                        <span>Your number will not be shared with anyone</span>\n                    </div>\n                    <div class="auth-actions">\n                        <button class="auth-btn entrMobleBtn">Next</button>\n                    </div>\n                </form>\n            </div>\n\n            <div id="div2" style="display:none;">\n                <div class="auth-hero">\n                    <h1 class="auth-hero-title">Enter verification code</h1>\n                    <p class="auth-hero-sub">We sent a code to <span class="auth-mobile" id="sendOtpMobile"></span></p>\n                </div>\n                <form id="OTPvalidateForm">\n                    <div class="auth-card">\n                        <div class="list inline-labels no-hairlines-md">\n                            <ul>\n                                <li class="item-content item-input auth-field">\n                                    <div class="item-inner">\n                                        <div class="item-input-wrap input_line">\n                                            <input type="text" name="otp" placeholder="6-digit OTP" maxlength="6" minlength="6" required validate pattern="[0-9]*" data-error-message="Please enter valid OTP !!" value="">\n                                        </div>\n                                    </div>\n                                </li>\n                            </ul>\n                        </div>\n                    </div>\n                    <div class="auth-links">\n                        <a href="#" id="changesNumber">Change number</a>\n                        <span class="auth-link-muted">\n                            <span id="timer" style="display: none;">Resend in <span id="countdown"></span>s</span>\n                            <a href="#" id="resentOTP" style="display: none;">Resend OTP</a>\n                        </span>\n                    </div>\n                    <div class="auth-actions">\n                        <button class="auth-btn">Verify</button>\n                    </div>\n                </form>\n            </div>\n\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};